import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../../widgets/Head';
import { ListColumns } from '../../widgets/ListColumns';
import { Text } from '../../widgets/Text';
import Image from '../../widgets/Image';
import Summary from '../../widgets/Summary';
import OpenSourcePage from './OpenSourcePage';

const dojoLogo = require('../../assets/images/logo/medium/dojo.svg');

const factory = create();

export const OpenSourceDojo = factory(function OpenSourceDojo() {
	return (
		<OpenSourcePage background="level3Red">
			{{
				head: (
					<Head
						title="Dojo Framework | SitePen"
						description="A modern, reactive TypeScript framework for building robust, enterprise-grade web applications."
					/>
				),
				hero: {
					title: 'Open Source',
					xlTitle: (
						<div>
							Dojo
							<br />
							Framework
						</div>
					)
				},
				page: (
					<Summary stack paddingBottom="md">
						{{
							image: <Image src={dojoLogo} size="lg" width={400} height={286} />,
							blurb: (
								<virtual>
									<Text type="large-body">
										SitePen’s answer to modern web engineering is Dojo
										Framework, a reactive TypeScript first framework that
										approaches application development with a continuing focus
										on the requirements of the Enterprise and the engineers who
										support it.
									</Text>
									<Text type="large-body">
										Modern Dojo builds on many of the lessons learned from our
										experience building and maintaining the Dojo Toolkit.
										Progress on Dojo Toolkit started to slow due to the time in
										which it was built. It needed to define many features years
										before they were standardized, but today it’s possible to
										leverage modern APIs and standards. Today’s JavaScript
										ecosystem is far more powerful and flexible, making it much
										easier to create something powerful that co-exists with the
										ecosystem rather than needing to create its own solution for
										every engineering challenge. But to be successful in
										creating JavaScript apps today, it often requires a wealth
										of knowledge and a substantial collection of decisions to
										make before productivity can be achieved. Modern Dojo also
										makes it super easy to update to newer versions of the
										framework through powerful CLI tools.
									</Text>
									<Text type="large-body">Dojo Framework aims to:</Text>
									<ListColumns
										columnCount={1}
										style="disc"
										paddingLeft="sm"
										itemPaddingBottom="sm"
									>
										<Text type="large-body">
											<Text type="none" bold>
												Remove Decision Paralysis
											</Text>{' '}
											– Dojo provides excellent out-of-the-box default
											decisions, while making it possible to change or
											override those defaults. This allows teams to be
											productive quickly while creating high performance
											applications by default.
										</Text>
										<Text type="large-body">
											<Text type="none" bold>
												Guide Engineers
											</Text>{' '}
											– Dojo provides an approach that helps engineers build
											applications with good architecture and performance best
											practices by default. For example, Dojo applications are
											PWAs by default, and provide incredibly simple
											approaches for rendering optimizations, code-splitting,
											and other performance without needing to rewrite
											application logic.
										</Text>
										<Text type="large-body">
											<Text type="none" bold>
												Provide Developer Ergonomics
											</Text>{' '}
											– Dojo aligns with modern standards and patterns without
											the cognitive overload of every design decision. For
											example, Dojo currently leverages webpack for various
											build optimizations, but most applications built with
											Dojo will never need to think about webpack
											configuration as Dojo does the right thing based on the
											application architecture. Dojo provides efficient
											tooling for creating and testing applications and UI
											widgets, type safety and accuracy via efficient
											TypeScript ergonomics, and much more.
										</Text>
										<Text type="large-body">
											<Text type="none" bold>
												Results
											</Text>{' '}
											– Dojo provides a modern Reactive framework leveraging
											TypeScript and by default creates applications with high
											performance, excellent architecture, efficient
											ergonomics, and alignment with modern standards. The
											result is applications that get engineered more
											efficiently, have incredible performance, and lower
											total cost of ownership due to ease of testing and
											maintenance.
										</Text>
									</ListColumns>
									<Text type="large-body">
										Dojo provides a stable foundation for users to build
										performant, extensible, and sustainable applications for the
										future.
									</Text>
								</virtual>
							)
						}}
					</Summary>
				)
			}}
		</OpenSourcePage>
	);
});

export default OpenSourceDojo;
